import React, { useEffect, useState } from "react";
import "./assignedWork.css";
import { QRCodeCanvas } from "qrcode.react";

const Workcompleted = () => {
  const [orders, setOrders] = useState([]);
  const [showPayment, setShowPayment] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);

  const employeeId = localStorage.getItem("employee_id");

  const statusStages = [
    "assigned",
    "on the way",
    "reached",
    "work started",
    "work completed"
  ];

  const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
  const PAYMENT_NOTE =
    "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

  // ✅ Fetch completed orders
  useEffect(() => {
    if (!employeeId) return;

    fetch(
      `https://www.actrofiteinfotech.com/rootservices/dashboard/assigned_work.php?employee_id=${employeeId}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const completedOrders = data.data.filter(
            (order) => order.order_status === "work completed"
          );
          setOrders(completedOrders);
        }
      })
      .catch((err) => console.error(err));
  }, [employeeId]);

  // ✅ Auto Update Employee Location Every 10 Seconds
  useEffect(() => {
    if (!employeeId) return;

    const updateEmployeeLocation = () => {
      if (!navigator.geolocation) {
        console.warn("Geolocation not supported by browser.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          fetch("https://www.actrofiteinfotech.com/rootservices/backend/update_agent_location.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
             body: JSON.stringify({ employee_id: employeeId, lat, lng }),
          })
            .then((res) => res.json())
            .then((data) => {
              console.log("✅ Location updated:", data);
            })
            .catch((err) => console.error("❌ Location update error:", err));
        },
        (error) => {
          console.error("Geolocation error:", error);
        }
      );
    };

    // run immediately once
    updateEmployeeLocation();

    // then run every 10 seconds
    const interval = setInterval(updateEmployeeLocation, 10000);

    // cleanup
    return () => clearInterval(interval);
  }, [employeeId]);

  const updateStatus = (order, newStatus) => {
    if (newStatus === "work completed") {
      setCurrentOrder(order);
      setShowPayment(true);
      return;
    }

    fetch(
      "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: order.id, order_status: newStatus })
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setOrders((prev) =>
            prev.map((o) =>
              o.id === order.id ? { ...o, order_status: newStatus } : o
            )
          );
        } else {
          alert("Failed to update status");
        }
      })
      .catch((err) => console.error(err));
  };

  const markPaymentDone = () => {
    if (!currentOrder) return;
    fetch(
      "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: currentOrder.id, order_status: "work completed" })
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setOrders((prev) =>
            prev.map((order) =>
              order.id === currentOrder.id
                ? { ...order, order_status: "work completed" }
                : order
            )
          );
          setShowPayment(false);
          alert("Payment confirmed and work marked as completed!");
        } else {
          alert("Failed to confirm payment");
        }
      })
      .catch((err) => console.error(err));
  };

  const getUpiLink = (amount) => {
    const UPI_ID = "8978975045-3@ybl";
    return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
      RECEIVER_NAME
    )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
  };

  return (
    <div className="assigned-work-container">
      <h2>My Completed Work</h2>

      {orders.length === 0 ? (
        <p className="no-work">No completed work found.</p>
      ) : (
        orders.map((order) => (
          <div key={order.id} className="assigned-card">
            <div className="card-header">
              <strong>{order.main_service}</strong> → {order.sub_service_title}
            </div>

            <div className="card-body">
              <p><strong>Order ID:</strong> {order.id}</p>
              <p><strong>Customer Name:</strong> {order.name}</p>
              <p><strong>Address:</strong> {order.address || "No address provided"}</p>

              {order.latitude && order.longitude && (
                <p>
                  <strong>Latitude:</strong> {order.latitude} <br />
                  <strong>Longitude:</strong> {order.longitude}
                </p>
              )}

              {order.custom_title && (
                <p><strong>Custom Title:</strong> {order.custom_title}</p>
              )}
              {order.custom_description && (
                <p><strong>Description:</strong> {order.custom_description}</p>
              )}
              <p>
                <strong>Booked At:</strong>{" "}
                {new Date(order.booked_at).toLocaleString()}
              </p>

              {order.image_url && (
                <img
                  src={order.image_url}
                  alt="Service"
                  className="order-image"
                />
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Workcompleted;
